import { useContext, useMemo } from "react";

import { IDynamicFormItemProps } from ".";

import DateInput from "components/DateInput/DateInput";
import { useTranslation } from "modules";
import formValidations from "modules/hooks/form/Validations";

import { DynamicFormContext } from "../DynamicFormContext";

export function DateInputItem({ item }: IDynamicFormItemProps<"inputDate">) {
  const { t } = useTranslation();
  const { form } = useContext(DynamicFormContext);

  const { content, key } = item;
  const { disabled } = content;
  const { label, value } = form.getFormInput(key);

  const errorMessages = form.getInputErrorMessage(key);
  const formattedErrorMessages = useMemo(
    () =>
      errorMessages.map(message => {
        const dateValidation = formValidations.validateDateFormatAndRange;
        const dateValidationMessage = dateValidation.defaultError;
        if (item.key === "birthdate" && message === dateValidationMessage) {
          const invalidDateMessage = t("form.validation.birthdate.valid", message);
          return invalidDateMessage;
        } else {
          return message;
        }
      }),
    [errorMessages, item.key, t]
  );

  return (
    <DateInput
      dataTestId={key}
      disabled={disabled}
      error={form.getInputError(key)}
      errorMessage={formattedErrorMessages}
      id={key}
      label={label}
      onBlur={form.onBlur}
      onChange={form.onChange}
      shouldDisplayUtcAsLocal
      value={value as string | undefined}
    />
  );
}
